import React, { useReducer } from 'react';
import alertaReducer from './alertaReducer';
import alertaContext from './alertaContext';
import clienteAxios from "../../service/axios";

import { 
    MOSTRAR_ALERTA, 
    OCULTAR_ALERTA,
    OBTENER_ALERTAS_VISTAS 
} from 'types/context';

const AlertaState = props => {
    const initialState = {
        alerta: null,
        alertasVistas: [],
    }

    const [state, dispatch] = useReducer(alertaReducer, initialState);

    // Funciones
    const mostrarAlerta = (msg, categoria) => {
        dispatch({
            type: MOSTRAR_ALERTA,
            payload: {
                msg,
                categoria
            }
        });

        // Después de 5 segundos limpiar la alerta
        setTimeout(() => {
            dispatch({
                type: OCULTAR_ALERTA
            })
        }, 5000);
    }

    const obtenerAlertasVistas = async (clienteId,estados,  supervision) => {
        try {
            // siempre deberia venir un cliente
            
            const resultado = await clienteAxios.get(`/alertasVistas?estados=${estados}&cliente=${clienteId}&supervision=${supervision}`);
            //console.log("context =>",resultado.data.historialAlertas);
            dispatch({
                type: OBTENER_ALERTAS_VISTAS,
                payload: resultado.data.historialAlertas?resultado.data.historialAlertas:[]
            });
            return resultado.data.historialAlertas?resultado.data.historialAlertas:[];
        } catch (error) {
            console.log(error)
            const alerta = {
                msg: error,
                categoria: 'error'
            }
            
        }
    }
    return (
        <alertaContext.Provider
            value={{
                alerta: state.alerta,
                alertasVistas: state.alertasVistas,
                obtenerAlertasVistas,                
                mostrarAlerta
            }}
        >
            {props.children}
        </alertaContext.Provider>
    )
}

export default AlertaState;